import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import '../App.css';
import Sidebar from '../componenteExtra/SidebarSolicitante';
import SessionManager from '../componenteExtra/SessionManager';

Modal.setAppElement('#root');

const PausedActivitiesSolicitante = () => {
    const [activities, setActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [feedbackComment, setFeedbackComment] = useState('');
    const [nombre_get, setNombreGet] = useState("");

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        // Obtener el nombre_get desde el localStorage
        const storedNombreGet = localStorage.getItem("nombre_get");
        setNombreGet(storedNombreGet);
      }, []);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/get_paused_activities/${nombre_get}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
            .then(response => {
                setActivities(response.data);
            })
            .catch(error => console.error('Error fetching paused activities: ', error));
    }, [nombre_get]);

    const handleAction = (activity) => {
        setSelectedActivity(activity);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedActivity(null);
        setFeedbackComment('');  // Resetea el comentario cuando se cierra el modal
    };

    const handleFeedbackSubmit = async () => {
        try {
            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/submit_feedback`, {
                id: selectedActivity.id,
                comentario_aclaracion: feedbackComment
            },
            {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  },
                )
            alert('Feedback enviado');
            handleCloseModal();
            window.location.reload();
        } catch (error) {
            console.error('Error submitting feedback:', error);
        }
    };

    const totalActividades = activities.length;

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Solicitudes pausadas - {nombre_get}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>
                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Código de Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Socio de auditoría</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Numero Grupo</th>
                                    <th>Staff</th>
                                    <th>Estado Pausa</th>
                                    <th>Definición Pausa</th>
                                    <th>Fecha de Inicio</th>
                                    <th>Fecha de Termino</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.encargado_auditoria}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>{activity.numero_grupo}</td>
                                        <td>{activity.staff_asignado}</td>
                                        <td>{activity.pausa}</td>
                                        <td>{activity.definicion_pausa}</td>
                                        <td>{activity.fecha_de_inicio}</td>
                                        <td>{activity.fecha_de_termino}</td>
                                        <td>
                                            <button className="action-button" onClick={() => handleAction(activity)}>Responder</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {selectedActivity && (
                <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal}>
                    <h1>Enviar Feedback</h1>
                    <p><strong>Código de Proyecto:</strong> {selectedActivity.codigo_proyecto}</p>
                    <p><strong>Razón Social:</strong> {selectedActivity.razon_social}</p>
                    <p><strong>Nombre Actividad GET:</strong> {selectedActivity.nombre_actividad_get}</p>
                    <p><strong>Staff:</strong> {selectedActivity.staff_asignado}</p>
                    <p><strong>Enlace Comentario:</strong> {selectedActivity.enlace_comentario}</p>
                    <p><strong>Causa de Pausa :</strong> {selectedActivity.pausa}</p>
                    <p><strong>Definición Pausa :</strong> {selectedActivity.definicion_pausa}</p>
                    
                    <textarea
                        value={feedbackComment}
                        onChange={(e) => setFeedbackComment(e.target.value)}
                        placeholder="Escribe tu comentario aquí..."
                        rows="4"
                        cols="50"
                    />
                    <br />
                    <button 
                        onClick={handleFeedbackSubmit} 
                        disabled={!feedbackComment.trim()}
                        className="feedback-button"

                    >
                        Enviar Feedback
                    </button>
                    <button onClick={handleCloseModal} className="close-button">Cerrar</button>
                </Modal>
            )}
        </div>
    );
};

export default PausedActivitiesSolicitante;
